export default __webpack_public_path__ + "static/unified1-b34d9088696cc5f152383a641da3d9db.png";